import axios from "axios";
import { getBaseUrl } from "../helpers/utils";

export const configureBaseUrl = (): void => {
  axios.defaults.baseURL = getBaseUrl() + "/v1";
  return;
};

export const configureAuthHeader = (token: string): void => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const unsetAuthHeader = (): void => {
  delete axios.defaults.headers.common["Authorization"];
};
